<template>
  <div>
    <div
      class="videogoods over-h"
      name="首页残品视频"
      ref="videogoods"
      v-for="(item, index) of list"
      :key="index"
    >
      <div v-if="item.type == 3">
        <img class="title radius-8px" :src="item.titleurl" />
        <div class="videogoods_tags flex-jc-ac pos-r zi-66" v-if="item.tagsList.length">
          <div
            v-for="(tagsitem, tagsindex) of item.tagsList"
            @click="videogoodsIndexFn(index, tagsindex)"
            class="f14"
            :style="{
              background:
                'url(' +
                (item.videoIndex == tagsindex ? tagsitem.selectedimg : tagsitem.defaultimg) +
                ') no-repeat left top'
            }"
          ></div>
        </div>
        <div
          class="banner"
          style="height: 6.06rem"
          :style="
            checkAgentStr == 'ios'
              ? { 'margin-top': '-0.36rem', 'margin-bottom': '-0.36rem' }
              : {}
          "
        >
          <swiper
            id="videogoods3DBanner"
            ref="videoSwiper"
            :options="{
              ...videogoods3DSwiper,
              ...(item.goodsList.length > 1 ? videogoods3DSwiperAutoPlay : {})
            }"
            :index="index"
            style="height: 100%"
            :style="checkAgentStr == 'ios' ? { width: '118%', 'margin-left': '-9%' } : {}"
          >
            <swiper-slide
              v-for="(goodsitem, goodsindex) of item.goodsList"
              :key="`slide-${goodsindex}`"
              style="height: 6.06rem; border-radius: 0"
            >
              <img
                class="radius-8px"
                :src="goodsitem.goodsimg"
                @error="
                  (event) => {
                    let img = event.srcElement
                    img.src = errorImg
                    img.onerror = null
                  }
                "
              />
              <div
                :path="
                  goodsitem.ad_target +
                  (goodsitem.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                  'sorce=8'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="isWx && (goodsitem.ad_type == 7 || goodsitem.ad_type == 8)"
              ></div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="pos-r zi-66" v-else-if="item.type == 2">
        <img class="title radius-8px" :src="item.titleurl" />
        <div
          class="bgimg radius-8px"
          :style="
            item.bgimg_url
              ? {
                  background: `url(${item.bgimg_url}) center center / 100% 100% no-repeat`
                }
              : {}
          "
        >
          <div class="videogoods_tags flex-jc-ac" v-if="item.tagsList.length">
            <div
              v-for="(tagsitem, tagsindex) of item.tagsList"
              @click="videogoodsIndexFn(index, tagsindex)"
              class="f14"
              :style="{
                background:
                  'url(' +
                  (item.videoIndex == tagsindex ? tagsitem.selectedimg : tagsitem.defaultimg) +
                  ') no-repeat left top'
              }"
            ></div>
          </div>
          <div
            class="activity"
            v-if="item.goodsList.length > 0"
            @click="bannerClickHandle(item.goodsList[0], 0, 'rtc-' + (index + 1) + '-' + 1)"
          >
            <swiper
              id="videogoodsBanner"
              ref="videoSwiper"
              :options="videogoodsSwiper"
              :index="index"
              style="height: 100%"
            >
              <swiper-slide
                ref="activityItem"
                v-for="(goodsitem, goodsindex) of item.goodsList"
                :key="goodsindex"
              >
                <div
                  class="image"
                  style="width: 100%; height: 100% !important; position: relative"
                  v-if="goodsitem.type == 1 && goodsitem.videourl"
                >
                  <div class="video zy_media">
                    <video
                      class="video_banner radius-8px"
                      :class="'video_banner-' + index + '-' + goodsindex"
                      :ref="'video_banner-' + index + '-' + goodsindex"
                      :poster="goodsitem.videoimgurl"
                      loop
                      muted
                      data-config="创客村"
                      webkit-playsinline
                      playsinline
                      x5-playsinline
                      x-webkit-airplay="allow"
                    >
                      <source :src="goodsitem.videourl" type="video/mp4" />
                      <source :src="goodsitem.videourl" type="video/m3u8" />
                      您的浏览器不支持HTML5视频
                    </video>
                  </div>
                </div>
                <div v-else-if="goodsitem.videourl" class="image" style="position: relative">
                  <img
                    :ref="'video_banner-' + index + '-' + goodsindex"
                    :src="goodsitem.videourl"
                    class="radius-8px"
                    @error="
                      (event) => {
                        let img = event.srcElement
                        img.src = errorImg
                        img.onerror = null
                      }
                    "
                  />
                </div>
              </swiper-slide>
            </swiper>
            <img class="baseimg radius-8px" style="width: 100%" :src="item.baseimg_url" />
          </div>
        </div>
      </div>
      <div class="pos-r zi-66" v-else>
        <img class="title radius-8px" :src="item.titleurl" />
        <div class="videogoods_tags flex-jc-ac" v-if="item.tagsList.length">
          <div
            v-for="(tagsitem, tagsindex) of item.tagsList"
            @click="videogoodsIndexFn(index, tagsindex)"
            class="f14"
            :style="{
              background:
                'url(' +
                (item.videoIndex == tagsindex ? tagsitem.selectedimg : tagsitem.defaultimg) +
                ') no-repeat left top'
            }"
          ></div>
        </div>
        <van-swipe
          id="videoBanner"
          class="swiper-container"
          ref="videoSwiper"
          style="height: 100%"
          :autoplay="5000"
          :show-indicators="false"
          :initial-swipe="item.initialIndex"
          @change="videogoodschange($event, index)"
        >
          <van-swipe-item
            class="swiper-slide"
            v-for="(goodsitem, goodsindex) of item.goodsList"
            :key="goodsindex"
          >
            <div
              class="image"
              style="width: 100%; height: 100% !important"
              v-if="goodsitem.type == 1 && goodsitem.videourl"
            >
              <div class="video zy_media">
                <video
                  class="video_banner radius-8px"
                  :class="'video_banner-' + index + '-' + goodsindex"
                  :ref="'video_banner-' + index + '-' + goodsindex"
                  :poster="goodsitem.videoimgurl"
                  loop
                  muted
                  data-config="创客村"
                  webkit-playsinline
                  playsinline
                  x5-playsinline
                  x-webkit-airplay="allow"
                >
                  <source :src="goodsitem.videourl" type="video/mp4" />
                  <source :src="goodsitem.videourl" type="video/m3u8" />
                  您的浏览器不支持HTML5视频
                </video>
              </div>
            </div>
            <div
              v-else-if="goodsitem.videourl"
              class="image"
              @click="
                bannerClickHandle(
                  goodsitem,
                  goodsindex,
                  'rtc-' + (index + 1) + '-' + (goodsindex + 1)
                )
              "
            >
              <img
                :ref="'video_banner-' + index + '-' + goodsindex"
                :src="goodsitem.videourl"
                class="radius-8px"
                @error="
                  (event) => {
                    let img = event.srcElement
                    img.src = errorImg
                    img.onerror = null
                  }
                "
              />
            </div>
            <div
              class="goods"
              @click="
                bannerClickHandle(
                  goodsitem,
                  goodsindex,
                  'rtc-' + (index + 1) + '-' + (goodsindex + 1)
                )
              "
            >
              <div
                v-if="goodsitem.type == 1 && goodsitem.videourl && goodsitem.is_play"
                class="click_play"
                @click.stop="videoClick(index, goodsindex)"
              >
                <div class="circle">
                  <div class="circle circleCh circleCh1 flex-jc-ac">
                    <van-icon color="#ffffff" size="0.13rem" name="play" />
                  </div>
                </div>
              </div>
              <img class="goodsimg radius-8px" :src="goodsitem.goodsimg" />
              <div
                :path="
                  goodsitem.ad_target +
                  (goodsitem.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                  'sorce=8'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="isWx && (goodsitem.ad_type == 7 || goodsitem.ad_type == 8)"
              ></div>
            </div>
            <div
              class="goods1"
              v-if="goodsitem.actimg"
              :class="{
                goods1_transform: item.videoIndex == goodsindex && item.goodsTransform
              }"
              @click="
                bannerClickHandle(
                  goodsitem,
                  goodsindex,
                  'rtc-' + (index + 1) + '-' + (goodsindex + 1)
                )
              "
            >
              <img class="goodsimg radius-8px" :src="goodsitem.actimg" />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { checkAgent, isWeixin } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'

export default {
  name: 'homeVideoGoods',
  mixins: [adExposeMixin],
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'rtc'
    },
  },
  data() {
    var that = this
    return {
      checkAgentStr: '',
      isWx: isWeixin() ? 1 : 0,
      videogoodsSwiper: {
        loop: true,
        loopAdditionalSlides: 3,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: -25,
        observer: true,
        observeParents: true,
        slidesPerView: 1.53,
        slidesPerGroup: 1,
        on: {
          slideChangeTransitionStart() {
            var i = parseInt(this.$el[0].attributes['index'].value)
            that.list[i].videoIndex = this.realIndex
            var el = this.$el[0] || this.$el
            that.notifyAdExposeCarouselHandle(el)
          }
        }
      },
      videogoods3DSwiper: {
        loop: true,
        loopAdditionalSlides: 4,
        effect: 'cube',
        cubeEffect: {
          shadow: false,
          slideShadows: false
        },
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart() {
            var i = parseInt(this.$el[0].attributes['index'].value)
            that.list[i].videoIndex = this.realIndex
            var el = this.$el[0] || this.$el
            that.notifyAdExposeCarouselHandle(el)
          },
          click: function () {
            var activeIndex = this.realIndex
            var i = parseInt(this.$el[0].attributes['index'].value)
            if (checkAgent() != 'Harmony') {
              that.bannerClickHandle(
                that.list[i].goodsList[activeIndex],
                activeIndex,
                that.flow_area_prefix + '-' + (i + 1) + '-' + (activeIndex + 1)
              )
            }
          }
        }
      },
      videogoods3DSwiperAutoPlay: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      }
    }
  },
  created() {
    this.checkAgentStr = checkAgent()
  },
  mounted() {
    this.$nextTick(() => {
      this.bindVideoSwiperHarmony()
      this.bindVideoGoodsExposeHandle()
    })
  },
  watch: {
    list: function () {
      this.scheduleAdExposeBindHandle(this.bindVideoGoodsExposeHandle)
    }
  },
  methods: {
    bannerClickHandle(items, index, flowArea) {
      this.$emit('banner-click', items, index, flowArea)
    },
    bindVideoGoodsExposeHandle: function () {
      var that = this
      var refs = this.$refs.videoSwiper
      if (!refs) return
      if (!Array.isArray(refs)) refs = [refs]
      for (var r = 0; r < refs.length; r++) {
        var comp = refs[r]
        if (!comp || !comp.$el) continue
        var group_index = parseInt(comp.$el.getAttribute('index') || r, 10)
        ;(function (gidx, c) {
          that.bindAdExposeCarouselHandle(c.$el, {
            get_index: function () {
              var g = that.list[gidx]
              if (g && typeof g.videoIndex === 'number') return g.videoIndex
              if (c.swiper && typeof c.swiper.realIndex === 'number') return c.swiper.realIndex
              return 0
            },
            get_item: function (idx) {
              var g = that.list[gidx]
              return (g && g.goodsList && g.goodsList[idx]) || {}
            },
            make_key: function (idx) {
              return that.flow_area_prefix + '-' + (gidx + 1) + '-' + (idx + 1)
            }
          })
        })(group_index, comp)
      }
    },
    bindVideoSwiperHarmony() {
      this.list.forEach((item, index) => {
        if (item.type == 3 && this.$refs.videoSwiper && this.$refs.videoSwiper[index]) {
          const swiperEl = this.$refs.videoSwiper[index].$el
          const eventType = checkAgent() == 'Harmony' ? 'click' : ''
          if (eventType) {
            swiperEl.addEventListener(eventType, (e) => {
              e.stopPropagation()
              let slideItem = null
              if (!e.target.closest('.swiper-slide') && e.target.children[0]) {
                const temp_i = e.target.children[0].children.length - 1
                slideItem = e.target.children[0].children[temp_i]
              } else {
                slideItem = e.target.closest('.swiper-slide')
              }
              if (slideItem) {
                const id = slideItem.dataset.swiperSlideIndex
                  ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
                  : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
                this.bannerClickHandle(
                  this.list[index].goodsList[id],
                  id,
                  'rtc-' + (index + 1) + '-' + (id + 1)
                )
              }
            })
          }
        }
      })
    },
    videogoodsIndexFn: function (index, tagsindex) {
      if (this.list[index].type == 3) {
        this.list[index].videoIndex = tagsindex
        this.$refs.videoSwiper[index].swiper.slideToLoop(tagsindex, 500, false)
      } else if (this.list[index].type == 2) {
        this.list[index].videoIndex = tagsindex
        this.$refs.videoSwiper[index].swiper.slideToLoop(tagsindex, 500, false)
      } else {
        this.$refs.videoSwiper[index].swipeTo(tagsindex, { immediate: false })
      }
    },
    videogoodschange(goodsIndex, index) {
      try {
        this.list[index].videoIndex = goodsIndex
        var len = this.list[index].goodsList.length,
          prevDom,
          nextDom,
          dom
        dom = this.$refs['video_banner-' + index + '-' + goodsIndex][0]
        if (this.list[index].videoIndex == 0) {
          prevDom = this.$refs['video_banner-' + index + '-' + (len - 1)][0]
          nextDom =
            this.$refs['video_banner-' + index + '-' + (this.list[index].videoIndex + 1)][0]
        } else if (this.list[index].videoIndex == len - 1) {
          prevDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.list[index].videoIndex - 1)
            ][0]
          nextDom = this.$refs['video_banner-' + index + '-0'][0]
        } else {
          prevDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.list[index].videoIndex - 1)
            ][0]
          nextDom =
            this.$refs[
              'video_banner-' + index + '-' + (this.list[index].videoIndex + 1)
            ][0]
        }
        if (
          dom.localName != 'img' &&
          this.list[index].goodsList[goodsIndex].is_play == 0
        ) {
          dom.play()
        }
        if (prevDom.localName != 'img') prevDom.pause()
        if (nextDom.localName != 'img') nextDom.pause()
      } catch (e) {}
    },
    videoClick(index, goodsIndex) {
      this.list[index].goodsList[goodsIndex].is_play = 0
      this.$refs['video_banner-' + index + '-' + goodsIndex][0].play()
    },
    onWindowScroll() {
      var domHight = document.body.offsetHeight,
        scrollTop =
          window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
        id,
        scrollHeight,
        offsetTop,
        top,
        bottom
      id = this.$refs.videogoods
      if (!id) return
      id.map((item, index) => {
        scrollHeight = item.scrollHeight
        offsetTop = item.offsetTop
        top = offsetTop - domHight > 0 ? offsetTop - domHight : 0
        bottom = scrollHeight + offsetTop
        if (scrollTop >= top && scrollTop <= bottom) {
          if (
            !this.list[index].goodsTransform &&
            scrollTop >= top + 480 &&
            scrollTop <= bottom - 200
          ) {
            this.list[index].goodsTransform = true
          }
          try {
            let dom =
              this.$refs['video_banner-' + index + '-' + this.list[index].videoIndex][0]
            if (dom.localName != 'img' && dom.paused) {
              this.list[index].goodsList[this.list[index].videoIndex].is_play = 1
            }
          } catch (e) {}
        } else {
          if (this.list[index].goodsTransform) {
            this.list[index].goodsTransform = false
          }
          try {
            let dom =
              this.$refs['video_banner-' + index + '-' + this.list[index].videoIndex][0]
            if (dom.localName != 'img') {
              dom.pause()
              this.list[index].goodsList[this.list[index].videoIndex].is_play = 1
              this.list[index].videoplay = 0
            }
          } catch (e) {}
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.videogoods {
  position: relative;
  margin: 0.1rem 0.11rem 0;
  .title {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 0.08rem;
  }
  .video {
    border-radius: 0.1rem;
  }
  video {
    width: 100%;
    object-fit: cover;
  }
  .image {
    width: 100%;
    height: 2.81rem;
    position: absolute;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods {
    width: 100%;
    position: relative;
    z-index: 2;
    .goodsimg {
      width: 100%;
      height: 4.23rem;
    }
  }
  .goods1 {
    width: 100%;
    height: 1.38rem;
    position: relative;
    top: -1.38rem;
    z-index: 1;
    transition: all 2s;
    padding: 0 0.13rem;
    img {
      width: 100%;
      height: 100%;
    }
    &.goods1_transform {
      top: 0;
    }
  }
  .videogoods_tags {
    height: 0.28rem;
    margin: 0 0.31rem 0.12rem;
    div {
      text-align: center;
      white-space: nowrap;
      line-height: 0.27rem;
      width: 0.96rem;
      color: #333;
      height: 100%;
      background-size: 100% 100% !important;
    }
  }
  .bgimg {
    padding-top: 0.16rem;
  }
  .activity {
    margin: 0.16rem 0 0;
    padding-bottom: 0;
    .image {
      height: 3.86rem;
    }
    .baseimg {
      margin-top: -0.84rem;
      position: relative;
      z-index: 2;
    }
  }
}
.click_play {
  z-index: 100;
  display: inline-block;
  position: absolute;
  left: 0.1rem;
  top: 0.18rem;
  .circle {
    width: 0.3rem;
    height: 0.3rem;
    background: transparent;
    border-radius: 50%;
    position: relative;
    .circleCh1 {
      width: 0.2rem;
      height: 0.2rem;
      text-align: center;
      font-size: 0;
      animation: myfirst 1s infinite;
    }
    .circleCh {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 0.01rem solid #ffffff;
      background: rgba(255, 255, 255, 0.35);
    }

    @keyframes myfirst {
      0% {
        transform: scale(1);
      }
      35% {
        transform: scale(1.1);
      }
      50% {
        transform: scale(1.5);
      }
      75% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
.banner {
  margin-top: -0.01rem;
  position: relative;
  border-radius: 0 0 100% 100%;
  height: 2.54rem;
  .swiper-wrapper {
    .swiper-slide {
      overflow: hidden;
      height: 2.54rem;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
</style>

<style lang="scss">
.index {
  .videogoods {
    > .swiper-container {
      border-radius: 0.1rem;
      .zy_controls,
      .dec_loading,
      .dec_error,
      .dec_play {
        display: none;
      }
    }
    .activity {
      .swiper-slide {
        transform: scale(0.8);
        transition: all 0.2s ease-in 0s;
        border-top-left-radius: 0.07rem;
        border-top-right-radius: 0.07rem;
      }
      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);
        border-top-left-radius: 0.04rem;
        border-top-right-radius: 0.04rem;
      }
    }
  }
  #videogoodsSwiperPagination {
    width: auto;
    font-size: 0;
    color: #ffffff;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }
  #videogoodsSwiperPagination {
    bottom: 0;
  }
  #videogoodsSwiperPagination {
    text-align: center;
    span {
      margin-left: 0.05rem;
      background: rgba(0, 0, 0, 0.2);
      &.swiper-pagination-bullet {
        width: 0.11rem;
        height: 0.02rem;
        border-radius: 0.01rem;
        margin: 0 !important;
        background: #cccccc;
      }
      &:first-child {
        margin-left: 0;
      }
      &.swiper-pagination-bullet-active {
        background: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeVideoGoods.vue